import { on } from '@ngrx/store';
import { createImmerReducer } from 'ngrx-immer/store';
import { ChatState } from './chat.types';
import {
  openChat,
  closeChat,
  toggleChat,
  loadMessages,
  loadMessagesSuccess,
  loadMessagesFailure,
  sendMessage,
  sendMessageSuccess,
  sendMessageFailure,
  clearMessages,
  addNewMessage,
} from './chat.actions';

export const initialChatState: ChatState = {
  messages: [],
  isResponseLoading: false,
  isLoading: true,
  isOpen: false,
  error: null,
};

export const chatReducer = createImmerReducer(
  initialChatState,

  // UI
  on(openChat, state => {
    state.isOpen = true;
    return state;
  }),
  on(closeChat, state => {
    state.isOpen = false;
    return state;
  }),
  on(toggleChat, state => {
    state.isOpen = !state.isOpen;
    return state;
  }),

  // Load messages
  on(loadMessages, state => {
    state.isLoading = true;
    state.error = null;
    return state;
  }),
  on(loadMessagesSuccess, (state, { messages }) => {
    state.messages = messages;
    state.isLoading = false;
    return state;
  }),
  on(loadMessagesFailure, (state, { error }) => {
    state.isLoading = false;
    state.error = error;
    return state;
  }),

  // Send message (two-level request)
  on(sendMessage, state => {
    state.isResponseLoading = true;
    state.error = null;
    return state;
  }),
  on(sendMessageSuccess, state => {
    state.isResponseLoading = false;
    return state;
  }),
  on(sendMessageFailure, (state, { error }) => {
    state.isResponseLoading = false;
    state.error = error;
    return state;
  }),

  on(addNewMessage, (state, { message }) => {
    state.messages.push(message);
    return state;
  }),
  // Clear
  on(clearMessages, state => {
    state.messages = [];
    state.error = null;
    return state;
  }),
);
